import React, {ChangeEvent, useRef} from 'react';
import {FieldProp, DiscussionHistoryItem} from '../../types';
import useAutosizeTextArea from '../../_hooks/useAutosizeTextArea';

type DiscussionProps = FieldProp & {};

export const Discussion: React.FunctionComponent<DiscussionProps> = ({
                                                                         field,
                                                                         fieldState,
                                                                         value,
                                                                         displayOnly,
                                                                         onChange,
                                                                         onBlur,
                                                                     }): JSX.Element => {
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    useAutosizeTextArea(textareaRef.current, value, {maxHeight: 250, minHeight: 100});

    const {
        touched,
        pristine,
        validating,
        valid,
        invalid,
        errors,
    } = fieldState;

    const classNames = [
        'form-control',
        touched && 'is-touched',
        pristine && 'is-pristine',
        validating && 'is-validating',
        valid && 'is-valid',
        invalid && 'is-invalid',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div>
            <div style={{
                maxHeight: '500px',
                overflow: 'scroll'
            }}>
            {field?.discussionHistory?.map((item: DiscussionHistoryItem) => (
                <div key={`gravityflow-discussion-item-${item.id}`}
                     className="gravityflow-discussion-item"
                >
                    <div className="gravityflow-dicussion-item-header">
                        <span className="gravityflow-dicussion-item-name">{item.userEmail}</span>
                        <span className="gravityflow-dicussion-item-date">{item.timestamp}</span>
                    </div>
                    <div className="gravityflow-dicussion-item-value">
                        <pre>{item.value}</pre>
                    </div>
                </div>
            ))}
            </div>
            {!displayOnly &&
            <textarea
                ref={textareaRef}
                id={field.htmlId}
                required={field.isRequired}
                readOnly={field.gwreadonly_enable}
                className={classNames}
                onBlur={() => {onBlur && onBlur()}}
                onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                    onChange(e.target.value)
                }}
                value={value}
            />
            }

            <div className="d-flex">
                <div className="flex-grow-1">
                    {errors && errors.map((error: string, index: number) => (
                        <div key={index} className="invalid-feedback">
                            {error}
                        </div>
                    ))}
                </div>

                {!displayOnly && field.maxLength &&
                <div className="text-right">
                    <span className="small text-muted">{value?.length || 0} of {field.maxLength}</span>
                </div>
                }
            </div>
        </div>
    );
};
